import { render, staticRenderFns } from "./Editprofile.vue?vue&type=template&id=05ec1029&scoped=true&"
import script from "./Editprofile.vue?vue&type=script&lang=js&"
export * from "./Editprofile.vue?vue&type=script&lang=js&"
import style0 from "./Editprofile.vue?vue&type=style&index=0&id=05ec1029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec1029",
  null
  
)

export default component.exports